<ebw-monorepo-sidebar-header
  [icon]="'space_dashboard'"
  [title]="'map.sidebar.dynamic_layers.add_layer_file'"
  [isSvg]="false"
  [isOutline]="true"
  [fill]="true"
>
  {{ 'map.sidebar.dynamic_layers.info_section_layer_file' | translate }}
</ebw-monorepo-sidebar-header>
<div class="mt-3">
  <div class="d-flex gap-2 align-content-center">
    <button *ngIf="canAddStyle" mat-flat-button (click)="addNewLayerStyle()" color="primary" class="w-100 add-layer-btn">
      <span>Aggiungi stile</span>
    </button>
    <button mat-flat-button (click)="getCustomStylesList()" color="primary" class="w-100 add-layer-btn">
      <span>{{ 'map.sidebar.shape.style_form.styles_list' | translate }}</span>
    </button>
  </div>

  <div class="shape-table-toolbar mb-2">
    <button
      mat-flat-button
      (click)="addNewShapeLayer()"
      color="primary"
      class="w-100 add-layer-btn"
      *ngIf="canAddLayer"
    >
      <span>Aggiungi livello</span>
    </button>
  </div>
  <div class="sidebar-layout-body">
    <div *ngIf="layersList.length === 0" class="d-flex justify-content-center">
      <h4>
        {{ 'common.no_result' | translate }}
      </h4>
    </div>
    <div class="list-wrapper" *ngIf="layersList.length > 0">
      <mat-list>
        <mat-list-item *ngFor="let layerItem of layersList; let i = index">
          <div class="list-item" matLine>
            <div class="toggle-container">
              <mat-slide-toggle
                [matTooltip]="'map.sidebar.dynamic_layers.on_off' | translate"
                [(ngModel)]="layerItem.visible"
                (ngModelChange)="setVisibility(layerItem)"
              >
              </mat-slide-toggle>
              <div
                class="text-capitalize text-truncate list-item-label"
                [matTooltip]="normalizeLabel(layerItem.info.label) | uuid : ' ' | normalize"
              >
                {{ normalizeLabel(layerItem.info.label) | uuid : ' ' | normalize }}
              </div>
            </div>
            <div>
              <button mat-icon-button matTooltip="Info" (click)="infoLayer(layerItem)">
                <mat-icon>info_outline</mat-icon>
              </button>

              <button
                mat-icon-button
                matTooltip="Center"
                color="accent"
                class="ml-auto"
                [disabled]="!layerItem?.info?.bbox"
                (click)="centerMap(layerItem.info)"
              >
                <mat-icon>location_searching</mat-icon>
              </button>

              <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="canEditLayer || canDeleteLayer">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  class="w-100"
                  *ngIf="(layerItem.info.user_id || this.publicPermission) && canEditLayer"
                  (click)="updateLayer(layerItem)"
                >
                  <mat-icon class="me-1">edit</mat-icon>
                  <span>{{ 'common.modify' | translate }}</span>
                </button>
                <button
                  mat-menu-item
                  class="w-100"
                  *ngIf="(layerItem.info.user_id || this.publicPermission) && canDeleteLayer"
                  (click)="removeLayer(layerItem)"
                >
                  <mat-icon class="me-1" color="warn">delete</mat-icon>
                  <span>{{ 'common.delete' | translate }}</span>
                </button>
                <button mat-menu-item class="w-100" (click)="openDialog(layerItem.info)">
                  <mat-icon class="me-1">legend_toggle</mat-icon>
                  <span>{{ 'map.sidebar.ebw_layers_configurator.legend' | translate }}</span>
                </button>
                <ebw-monorepo-opacity-slider [layerId]="layerItem.id" [icon]="true"></ebw-monorepo-opacity-slider>
              </mat-menu>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>
